import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  url: string;
};

type ResponseType = {
  data: any;
  meta: any;
};

export const addSourceURL = async (payload: APIPayload) => {
  try {
    const response = await Axios.get(
      `/files/upload_from_url?url=${payload.url}`,
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useAddSourceURL = () => {
  return useMutation<ResponseType, Error, APIPayload>({
    mutationFn: (payload: APIPayload) => addSourceURL(payload),
    onSuccess: (data) => {
      toast.success('Source URL Added Successfully');
      console.log(data);
    },
    onError: (error) => {
      toast.error('Adding Source URL Failed', { description: error.message });
    },
  });
};
